<template>
  <div>
    <section class="h-100 d-flex justify-center align-center">
      <v-container fill-height>
        <h1 :class="($vuetify.breakpoint.smAndDown && 'display-1') || 'display-3'">Hello there 👏,</h1>
        <h1 :class="($vuetify.breakpoint.smAndDown && 'display-1') || 'display-3'" class="grey--text font-weight-light">
          I am Janis Rozenfelds.
        </h1>
        <h1 :class="($vuetify.breakpoint.smAndDown && 'display-1') || 'display-3'" class="grey--text font-weight-light">
          I help humans to fulfill their vision by building cohesive ideas to final execution. Designer, Brand
          experience, Filmmaker, full-stack developer.
        </h1>
      </v-container>
    </section>
    <section class="h-50 my-10">
      <v-container>
        <v-subheader>Latest personal projects</v-subheader>
        <v-row class="mb-10">
          <v-col cols="12" sm="6">
            <v-card color="#0c0c0c" height="250">
              <v-card-title class="display-1">👉 User Profile Plugin</v-card-title>
              <v-card-text>
                <h2 class="font-weight-light">Build for powerful design tools Figma and Adobe XD.</h2>
              </v-card-text>
              <v-card-actions>
                <v-btn rounded :to="'user-profile-plugin'">View more</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card color="#0c0c0c" height="250">
              <v-badge overlap offset-x="20" offset-y="30" color="black">
                <template v-slot:badge>in production</template>
                <v-card-title class="display-1">👉 Nice Jobs</v-card-title>
              </v-badge>
              <v-card-text class="pt-0">
                <h2 class="font-weight-light">Discover the right job for you.</h2>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="h-50">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6">
            <h1
              :class="($vuetify.breakpoint.smAndDown && 'display-1') || 'display-3'"
              class="grey--text font-weight-light mb-10"
            >
              Currently Living: Designer at
              <span class="text-decoration-line-through mr-5">🇱🇻 Riga</span>
              <span class="text-decoration-line-through">🇩🇰 Copenhagen</span>
              now in Seoul, 🇰🇷 South Korea.
            </h1>
          </v-col>
          <v-col cols="12" sm="6">
            <h1
              :class="($vuetify.breakpoint.smAndDown && 'display-1') || 'display-3'"
              class="grey--text font-weight-light mb-5"
            >
              Drop me a line for project – Just say Hello. I look forward to hearing from you!
            </h1>
            <v-btn :x-large="($vuetify.breakpoint.smAndUp && true) || false" @click="onEmailTo" outlined rounded>
              Get in touch
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <p class="grey--text font-weight-light">Designed and made with 🖤 Janis Rozenfelds</p>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',

  methods: {
    onEmailTo() {
      window.open('mailto:janis.rozenfelds@gmail.com?Subject=Hello%20Janis', '_top')
    },
  },
}
</script>

<style scoped>
/*  */
</style>
